import React from 'react';
import { useRemoteData } from '../../../../../../model/data';
import { loadContingent } from '../../../../../../model/contingent';
import { Select, Option } from '../../../../../../components/Form/Select/Select';
import { t } from '../../../../../../locales/translate';
import { Event } from '../../../../../../model/event';
import { useErrorHandler } from '../../../../../../util/util';

interface Props {
  modelEvent: Event;
  sectionId: string;
  cacheKey: string;
}

export default function EventPools({ modelEvent, sectionId, cacheKey }: Props): JSX.Element | null {
  const [event, loading, error] = useRemoteData(
    async () => await loadContingent(modelEvent, sectionId),
    (db) => {
      return db.table('events').find(modelEvent.id);
    },
    [modelEvent.id, sectionId, cacheKey]
  );
  useErrorHandler(error);

  const contingent = event?.contingents?.find((contingent) => contingent.sectionId === sectionId);
  const pools: Option[] = contingent?.pools?.map((e) => ({ value: e.name, label: `${e.name} (${e.count})` })) ?? [];

  return (
    <Select
      loading={loading}
      name="pool"
      options={pools}
      label={t.model.contingent.pool}
      required
      allowEmpty={`Available (${contingent?.available || 0})`}
      displayWithoutOptions
      disabled={!contingent || !pools.length}
    />
  );
}
